import React from 'react';
import envelope from 'images/envelope.svg';
import sentSwooshes from 'images/sent_swooshs.svg';
import { Button } from 'ui';

const SuccessMessage = ({ onClose, i18n }) => (
  <div className="Modal-container">
    <div className="ta-c bg-green">
      <div className="ExpertPopout-image">
        <img alt="Envelope" src={envelope} />
      </div>
      <div className="ExpertPopout-waves">
        <img alt="Sent Swooshes" src={sentSwooshes} />
      </div>
      <div className="ExpertPopout-body">
        <p>
          <strong>{i18n.title}</strong>
        </p>
        <p>{i18n.body}</p>
        <Button onClick={onClose} tall>
          {i18n.close}
        </Button>
      </div>
    </div>
  </div>
);

export default SuccessMessage;
